import { useMemo } from "react";

import useActiveSection from "../../hooks/useActiveSection";
import useAnchorNav from "../../hooks/useAnchorNav";
import useI18n from "../../i18n/useI18n";
import { homeSections } from "../../data/navConfig";

// Fixed dot-rail marking the active Home section. Hidden under 1400px (CSS).
const SectionRail = () => {
  const ids = useMemo(() => homeSections.map((s) => s.id), []);
  const active = useActiveSection(ids);
  const navigateToHash = useAnchorNav();
  const { t } = useI18n();

  return (
    <nav className="section-rail" aria-label={t("nav.primary")}>
      {homeSections.map((section) => (
        <a
          key={section.id}
          href={`#${section.id}`}
          className={`section-rail__dot${active === section.id ? " is-active" : ""}`}
          aria-current={active === section.id ? "true" : undefined}
          aria-label={t(section.labelKey)}
          onClick={(event) => {
            event.preventDefault();
            navigateToHash(section.id);
          }}
        >
          <span className="section-rail__label">{t(section.labelKey)}</span>
        </a>
      ))}
    </nav>
  );
};

export default SectionRail;
